import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Stay informed about the latest dining trends and culinary news on First-Class.com. Explore gourmet experiences and gastronomic delights'
          }
        />
        <title>Dining News: Stay Informed on Culinary Trends</title>
      </Head>
      <ArticlesList subtype="News" type="Dining" />
    </>
  );
}

export default withLayout(News, true);
